import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { getPathWithoutLastFragment } from '@app/shared/helpers/location';
import { ErrorDetails } from '@app/shared/helpers/uploader';
import { DialogRef } from '@ngneat/dialog';
import { ClipboardService } from 'ngx-clipboard';

@Component({
  selector: 'app-modal-fatal-upload-error',
  templateUrl: './modal-fatal-upload-error.component.html',
  styleUrls: ['./modal-fatal-upload-error.component.scss']
})
export class ModalFatalUploadErrorComponent implements OnInit {

  errorName?: string;
  errorMessage?: string;
  errorId?: string;
  errorDetails?: ErrorDetails;

  fileReaderErrorNames =  [
    'FileSystemNotFoundError',
    'FileSystemPermissionDeniedError',
    'FileSystemUnknownError',
    'FileReaderNotFoundError',
    'FileReaderSecurityError',
    'FileReaderNotReadableError',
    'FileReaderNotReadableError',
    'FileReaderAbortError',
    'FileSystemAbortError',
  ];

  constructor(
    private router: Router,
    public ref: DialogRef,
    private clipboardService: ClipboardService,
    private route: ActivatedRoute,
  ) {
    this.errorName = this.ref.data.errorName;
    this.errorMessage = this.ref.data.errorMessage;
    this.errorId = this.ref.data.errorId;
    this.errorDetails = this.ref.data.errorDetails;
  }

  ngOnInit(): void { }

  get isFileReaderError() {
    return this.fileReaderErrorNames.includes(this.errorName);
  }

  get isDropboxDisabledError() {
    return this.errorName === 'DropboxDisabledError';
  }

  get isUnknownError() {
    return !this.isFileReaderError && !this.isDropboxDisabledError;
  }

  retry() {
    this.ref.close();
    this.router.navigate([getPathWithoutLastFragment() + '/'], { relativeTo: this.route });
  }

}
